import React from "react";
import styles from "./TemplateRow.module.css";
import { CustomButton, CustomIconButton, CustomTooltip, icon } from "../../../../../../common/components";
import { translateTemplates } from "../../../../utils/utils";
import { TEMPLATE_TYPES } from "../../constants";

export default function TemplateRow({ onDelete, onSelectRow, template }) {
	return (
		<div key={template.id} className={styles.row}>
			<CustomTooltip showWhenOverflow title={template.name}>
				<div className={styles.name}>{template.name}</div>
			</CustomTooltip>
			<CustomTooltip showWhenOverflow title={translateTemplates(template.excelTemplateTypeEnum)}>
				<div className={styles.type}>{translateTemplates(template.excelTemplateTypeEnum)}</div>
			</CustomTooltip>
			<div className={styles.projects}>
				{template.excelTemplateTypeEnum === TEMPLATE_TYPES.REQUIREMENTS && (
					<CustomButton
						variant="outlined"
						onClick={() => {
							onSelectRow(template, "projects");
						}}
					>
						{template.projects}
					</CustomButton>
				)}
			</div>
			<div className={styles.actions}>
				<CustomIconButton
					icon={icon.faEdit}
					size="sm"
					variant="outlined"
					onClick={() => {
						onSelectRow(template, "edit");
					}}
				/>
				<CustomIconButton
					icon={icon.faTrash}
					size="sm"
					variant="outlined"
					onClick={() => onDelete(template.id)}
				/>
			</div>
		</div>
	);
}
